<template>
  <v-app
    style="
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    "
  >
    <div style="width: 100%">
      <NavBar />
    </div>
    <div style="flex: 1; width: 100%; overflow: auto">
      <router-view :key="$route.fullPath" />
    </div>
    <div style="width: 100%">
      <FooterApp />
    </div>
  </v-app>
</template>

<script>
import FooterApp from "./components/FooterApp.vue";
import NavBar from "./components/NavBar";
export default {
  name: "App",
  components: { NavBar, FooterApp },
  data: () => ({
    //
  }),
};
</script>
<style>
.swal2-overlay {
  font-family: "Roboto", Helvetica, sans-serif !important;
}
.swal2-title {
  font-family: "Roboto", Helvetica, sans-serif !important;
}
.swal2-popup {
  font-family: "Roboto", Helvetica, sans-serif !important;
}

.bg {
  background-color: #d6d6d6;
}
body {
  overflow: hidden;
}
</style>
